
import { all, fork, call, put, select, takeLatest, takeEvery } from '@redux-saga/core/effects'
import { jwtDecode } from 'jwt-decode';
import * as appTypes from './appTypes';
import * as appActions from './appActions';
import * as authActions from './../../auth/store/authActions';
import {
  addAppointment,
  getClinics,
  adddPatient,
  getPatient,
  getAppointment,
  updateStatus,
  getAppointmentById,
  getPatientById,
  getPatientInfoById,
  getTagByPatientId,
  getTags,
  postMedicalRecord,
  getMedicalRecordByPatientId,
  getMedicalRecordById,
  deleteMedicalRecordById,
  deleteMessageById,
  fetchAvailability,
  getTemplateByClinicId,
  postTemplate,
  postFollowup,
  postMessage,
  getBillingsByPatientId,
  getBillingById,
  getMessagesByPatientId,
  getReportsByPatientId,
  getTreatmentByPatientId,
  getFollowupByPatientId,
  getReportViewById,
  getReportDownloadById,
  getDoctorProfileById,
  getClinicProfileById,
  postClinicProfile,
  getAreaByPatientId,
  getAreas,
  updatePatientById,
  updatePatientInfoById,
  updateTagById,
  updateAreaById,
  postTag,
  postArea,
  postPatientInfo,
  postTreatment,
  postUpload,
  postBilling,
  postStaff,
  postClinic,
  getStaff,
  getPatientHistory,
  postDoctorProfile,
  postTask,
  getTask,
  postComment,
  getBilling,
  getSummary,
  getGoogleAuthUrl,
  getAppointmentByPatientId,
  getTreatmentById,
  disconnectCalendarById,
  getSummaryStat,
  getMonthlyAppointments,
  getTaskOverview,
  getAppointmentStatusSummary,
  getTransactions,
  getPendingTransactions,
  getAvgEarningAndFollowUpRate,
  getAvailability,
  updateAvailability,
  postUploadLogo,
  getAvailableSlots,
  patientLookup,
  updateClinicById,
  getClinicById,
  postProfilePic,
  getCustomFieldsByClinicId,
  postCustomPatientFields,
  getAllDoctors

} from '../api/appApi';
import { replace } from 'redux-first-history';
import { extractParams, replaceParams } from '../../../../src/utils/url';
import storage from 'src/utils/storageUtils';
import { getUserFromToken } from 'src/DecodeToken';

function* handlePostPatient(action) {

  const { data, resolve, reject } = action.payload;
  console.log("Saga Data:", data);
  try {
    const updatedData = {
      ...data,
    }
    const newPatient = yield call(adddPatient, updatedData)
    yield put(appActions.postPatientSuccess(newPatient));
    if (resolve) resolve(newPatient);
  } catch (error) {
    const { reject } = action.payload;
    if (reject) reject(error);
  }
}

function* handlePostAppointment(action) {
  try {
    const { data, resolve, reject } = action.payload;
    console.log('Saga Data:', data);
    const updatedDatas = {
      ...data,
      // user: getUserIdFromToken(),
    };
    console.log('Updated Data:', updatedDatas);

    const newAppointment = yield call(addAppointment, updatedDatas);
    console.log('New Appointment:', newAppointment);

    yield put(appActions.postAppointmentSuccess(newAppointment.tokenappointment));
    if (resolve) resolve(newAppointment)

  } catch (error) {
    console.error('Saga Error:', error.message || error);
    console.error('Error details:', error.response ? error.response.data : 'No response data');
    yield put(appActions.postAppointmentFailure(error));

    if (action.payload.reject) {
      action.payload.reject(error);
    }
    // if (reject) reject(error);
  }
}

function* handleGetAppointment(action) {
  const { token, params, resolve, reject } = action.payload;
  try {
    const response = yield call(getAppointment, { token, params });
    console.log("get Appointment response", response);
    if (response && response.data) {
      yield put(appActions.getAppointmentSuccess(response));
      if (resolve) resolve(response)
    } else {
      const error = new Error("No Data Found");
      yield put(appActions.getAppointmentFailure(error));
    }
  } catch (error) {
    yield put(appActions.getAppointmentFailure(error));
    if (reject) reject(error)
  }
}

function* handleGetAppointmentById(action) {
  try {
    const { appointmentId } = action.payload;
    const response = yield call(getAppointmentById, appointmentId);
    yield put(appActions.getAppointmentByIdSuccess(response));

  } catch (error) {
    yield put(appActions.getAppointmentByIdFailure(error.message || 'Failed to Fetch Appointment Data'))
  }
}

function* handleGetAppointmentByPatientId(action) {
  const { patientId, resolve, reject } = action.payload;
  try {
    const response = yield call(getAppointmentByPatientId, patientId);
    if (response) {
      yield put(appActions.getAppointmentByPatientIdSuccess(response));
      if (resolve) resolve(response);
    }
  } catch (error) {
    const err = error?.response?.data?.message || error.message || 'Something went wrong';
    yield put(appActions.getAppointmentByPatientIdFailure(err));
    if (reject) reject(err);
  }
}

function* handleGetClinic(action) {
  try {
    const location = window.location;
    const pathname = location.pathname;

    const validPathRegex = /^\/[^/]+\/[^/]+\/(billings|clinics|patients|dashboard|...)$/;
    const isSidebarPath = validPathRegex.test(pathname);

    const clinics = yield call(getClinics);
    const firstClinic = clinics.data?.[0];
    const fallbackDoctorId = getUserFromToken();

    yield put(appActions.setClinics(clinics));

    if (isSidebarPath) {
      const parts = pathname.split('/');
      const clinicId = parts[1];
      const doctorId = parts[2];

      yield put(appActions.setCurrentClinics({ clinicId, doctorId }));
    } else {
      const clinicId = firstClinic?.id;
      const doctorId = fallbackDoctorId;

      if (clinicId && doctorId) {
        yield put(appActions.setCurrentClinics({ clinicId, doctorId }));
      }
    }
  } catch (error) {
    console.error('[handleGetClinic] Error:', error);
  }
}

// function* handleGetPatient(action) {
// const { token, resolve, reject } = action.payload;
// try {
// const response = yield call(getPatient, token);
// console.log("Get Patient API Response:", response);
// if (response && response.data) {
// yield put(appActions.getPatientSuccess(response.data));
// if (resolve) {
// console.log("Resolving with data:", response.data);
// resolve(response.data);
// }
// } else {
// const error = new Error('No Data Found');
// yield put(appActions.getPatientFailure(error));
// if (reject) reject(error);
// }
// } catch (error) {
// yield put(appActions.getPatientFailure(error));
// if (reject) reject(error);
// }
// }
// function* handleGetClinic(action) {
// try {
// yield put(appActions.setAppLoading(true));
// const referenceURL = 'http://localhost:3000/:clinicId/:doctorId/xyz';
// const location = window.location;
// const params = extractParams(referenceURL, location.href);

// const clinics = yield call(getClinics);
// const firstClinic = clinics.data?.[0];
// const doctorId = getUserIdFromToken(); // or from firstClinic.doctors?.[0]?.id

// if ((!params.clinicId || !params.doctorId) && firstClinic && doctorId) {
// const newUrl = replaceParams(referenceURL, location.href, firstClinic.id, doctorId);

// if (newUrl !== location.href) {
// yield put(replace(newUrl));
// return;
// }
// }

// yield put(appActions.setClinics(clinics));
// yield put(
// appActions.setCurrentClinics({
// clinicId: params.clinicId || firstClinic?.id,
// doctorId: params.doctorId || doctorId,
// }),
// );
// yield put(appActions.setAppLoading(false));
// } catch (error) {
// console.error('[handleGetClinic] Error:', error);
// yield put(appActions.setAppLoading(false));
// }
// }

function* handleGetPatient(action) {
  const { token, params, resolve, reject } = action.payload;
  try {
    const response = yield call(getPatient, { token, params });
    if (response && response.data) {
      yield put(appActions.getPatientSuccess(response));
      if (resolve) resolve(response);
    } else {
      const error = new Error('No Data Found');
      yield put(appActions.getPatientFailure(error));
      if (reject) reject(error);
    }
  } catch (error) {
    yield put(appActions.getPatientFailure(error));
    if (reject) reject(error);
  }
}

function* handleGetPatientById(action) {
  const { patientId, resolve, reject } = action.payload;
  try {
    const response = yield call(getPatientById, patientId);
    yield put(appActions.getPatientByIdSuccess(response));
    if (resolve) resolve(response)

  } catch (error) {
    yield put(appActions.getPatientByIdFailure(error.message || 'Failed to Fetch Patient Data'))
    if (reject) reject(error)
  }

}
function* handleGetPatientInfoById(action) {
  const { patientId, resolve, reject } = action.payload;
  try {
    const response = yield call(getPatientInfoById, patientId);
    if (response && response.data) {
      yield put(appActions.getPatientInfoByIdSuccess(response.data));
      if (resolve) resolve(response.data)
    } else {
      const error = new Error("No Data Found");
      yield put(appActions.getPatientInfoByIdFailure(error));
    }

  } catch (error) {
    yield put(appActions.getPatientInfoByIdFailure(error));
    if (reject) reject(error)
  }

}

//GET TAGS BY6 PATIENT ID
function* handleGetTagByPatientId(action) {
  const { patientId, resolve, reject } = action.payload;
  try {
    const response = yield call(getTagByPatientId, patientId);

    if (response && response.data) {
      yield put(appActions.getTagByPatientIdSuccess(response.data));
      if (resolve) resolve(response.data)
    } else {
      const error = new Error("No Data Found");
      yield put(appActions.getTagByPatientIdFailure(error));
    }

  } catch (error) {
    yield put(appActions.getTagByPatientIdFailure(error));
    if (reject) reject(error)
  }

}
//GET ALL TAGS
function* handleGetTags(action) {
  const { token, resolve, reject } = action.payload;
  try {
    const response = yield call(getTags, token);
    if (response && response.data) {
      yield put(appActions.getTagsSuccess(response.data));
      if (resolve) resolve(response.data);
    }
  } catch (error) {
    yield put(appActions.getTagsFailure(error));
    if (reject) reject(error);
  }
}
//GET AREA BY PATIENT ID
function* handleGetAreaByPatientId(action) {
  const { patientId, resolve, reject } = action.payload;
  try {
    const response = yield call(getAreaByPatientId, patientId);

    if (response && response.data) {
      yield put(appActions.getAreaByPatientIdSuccess(response.data));
      if (resolve) resolve(response.data)
    }
  } catch (error) {
    yield put(appActions.getAreaByPatientIdFailure(error));
    if (reject) reject(error)
  }
}
function* handleGetAreas(action) {
  const { token, resolve, reject } = action.payload;
  try {
    const response = yield call(getAreas, token);

    if (response) {
      yield put(appActions.getAreasSuccess(response));
      if (resolve) resolve(response);

    }
  } catch (error) {
    yield put(appActions.getAreasFailure(error));
    if (reject) reject(error);
  }

}

function* handlePostMedicalRecord(action) {
  const { data, resolve, reject } = action.payload;
  const updatedData = {
    ...data,
  }

  try {
    const response = yield call(postMedicalRecord, updatedData);
    yield put(appActions.postMedicalRecordsSuccess(response));
    if (resolve) resolve(response)
  } catch (error) {
    yield put(appActions.postMedicalRecordsFailure(error));
    if (reject) reject(error)
  }
}

function* handleGetMedicalRecord(action) {
  const { patientId, resolve, reject } = action.payload;

  try {
    const response = yield call(getMedicalRecordByPatientId, patientId);
    if (response && response.data) {
      yield put(appActions.getMedicalRecordSuccess(response))
    }
    if (resolve) resolve(response)

  } catch (error) {
    yield put(appActions.getMedicalRecordFailure(error))
    if (reject) reject(error)
  }

}

function* handleGetMedicalRecordById(action) {
  const { medicalId, resolve, reject } = action.payload;

  try {
    const response = yield call(getMedicalRecordById, medicalId);
    if (response && response.medicalRecord) {
      yield put(appActions.getMedicalRecordsByIdSuccess(response.medicalRecord))
    }
    if (resolve) resolve(response.medicalRecord)
  } catch (error) {
    yield put(appActions.getMedicalRecordsByIdFailure(error))
    if (reject) reject(error)
  }
}

function* handleDeleteMedicalRecord(action) {
  const { id, resolve, reject } = action.payload;

  try {
    const response = yield call(deleteMedicalRecordById, id);
    console.log("here is the saga api response", response)

    if (response) {
      yield put(appActions.deleteMedicalRecordSuccess(id));
      if (resolve) resolve(response.data || {});
    } else {
      const error = new Error(response.data?.message || 'Error deleting notes');
      yield put(appActions.deleteMedicalRecordFailure(error));
      if (reject) reject(error);
    }
  } catch (error) {
    console.log(error);
    yield put(appActions.deleteMedicalRecordFailure(error));
    if (reject) reject(error);
  }
}

function* handleUpdateStatusRecord(action) {
  const { appointmentId, data, resolve, reject } = action.payload;
  try {
    const response = yield call(updateStatus, appointmentId, data);
    console.log("status changed", response);
    if (response && response.tokenAppointment) {
      yield put(appActions.updateRecordStatusSuccess({ data: response.tokenAppointment }));
      if (resolve) resolve(response);
    } else {
      yield put(appActions.updateRecordStatusFailure('No status updated'));
    }

  } catch (error) {
    yield put(appActions.updateRecordStatusFailure(error));
    if (reject) reject(error);
  }
}

function* handleGetTemplateByClinicId(action) {
  const { clinicId, resolve, reject } = action.payload;
  try {
    const response = yield call(getTemplateByClinicId, clinicId);
    if (response) {
      // response is already the data body from the api utility
      const templateData = response.data || response;
      yield put(appActions.getTemplateByClinicIdSuccess(templateData))
      if (resolve) resolve(templateData)
    }

  } catch (error) {
    yield put(appActions.getTemplateByClinicIdFailure(error));
    if (reject) reject(error)
  }
}

function* handlePostTemplate(action) {
  const { data, resolve, reject } = action.payload;

  try {
    const response = yield call(postTemplate, data);

    if (response) {
      yield put(appActions.postTemplateSuccess(response));

      if (resolve) resolve(response)
    } else {
      yield put(appActions.postTemplateFailure("No template Added"));
      if (reject) reject("No template Added");
    }
  } catch (error) {
    console.error("Error in handlePostTemplate Saga:", error);
    yield put(appActions.postTemplateFailure(error));

    if (reject) reject(error)
  }
}

function* handlePostFollowup(action) {
  const { data, resolve, reject } = action.payload;

  try {
    const response = yield call(postFollowup, data);

    if (response) {
      yield put(appActions.postFollowupSuccess(response));

      if (resolve) resolve(response)
    }
  } catch (error) {
    console.error("Error in handlePostFollowup Saga:", error);
    yield put(appActions.postFollowupFailure(error));

    if (reject) reject(error)
  }
}

function* handleGetFollowupByPatientId(action) {
  const { patientId, resolve, reject } = action.payload;

  try {
    const response = yield call(getFollowupByPatientId, patientId);
    if (response && response.data) {
      yield put(appActions.getFollowupByPatientIdSuccess(response))
    }
    if (resolve) resolve(response)

  } catch (error) {
    yield put(appActions.getFollowupByPatientIdFailure(error))
    if (reject) reject(error)
  }
}
//get avialbility
function* handlefetchAvailability(action) {
  const { clinicId, resolve, reject } = action.payload;
  try {
    const response = yield call(fetchAvailability, clinicId);

    if (response) {

      yield put(appActions.fetchAvailabilitySuccess(response.data));
      console.log("here is saga response of Availability", response.data)
      if (resolve) resolve(response.data);

    } else {
      const error = new Error('No data found');
      yield put(appActions.fetchAvailabilityFailure(error));
    }
  } catch (error) {
    console.error('Error fetching availability:', error);
    yield put(appActions.fetchAvailabilityFailure(error));
    if (reject) reject(error);
  }
}

//GET_BILLING_BY_PATIENT_ID
function* handleGetBillingsByPatientId(action) {
  const { patientId, resolve, reject } = action.payload;
  try {
    const response = yield call(getBillingsByPatientId, patientId);
    if (response) {
      yield put(appActions.getBillingsByPatientIdSuccess(response));
      if (resolve) resolve(response);
    }
  } catch (error) {
    const err = error?.response?.data?.message || error.message || 'Something went wrong';
    yield put(appActions.getBillingsByPatientIdFailure(err));
    if (reject) reject(err);
  }
}

//GET_BILLING_BY_ID
function* handleGetBillingsById(action) {
  const { billingId, resolve, reject } = action.payload;
  try {
    const response = yield call(getBillingById, billingId);
    if (response) {
      yield put(appActions.getBillingByIdSuccess(response));
      if (resolve) resolve(response);
    }
  } catch (error) {
    const err = error?.response?.data?.message || error.message || 'Something went wrong';
    yield put(appActions.getBillingByIdFailure(err));
    if (reject) reject(err);
  }
}
//POST_MESSAGE
function* handlePostMessage(action) {
  const { data, resolve, reject } = action.payload;
  try {
    const response = yield call(postMessage, data);
    if (response) {
      yield put(appActions.postMessageSuccess(response));
      if (resolve) resolve(response)
    }
  } catch (error) {
    yield put(appActions.postMessageFailure(error));
    if (reject) reject(error)
  }
}
//GET_MESSAGE_BY_PATIENT_ID
function* handleGetMessageByPatientId(action) {
  const { patientId, resolve, reject } = action.payload;
  try {
    const response = yield call(getMessagesByPatientId, patientId)
    if (response) {
      yield put(appActions.getMessageByPatientByIdSuccess(response))
      if (resolve) resolve(response)
    }
  } catch (error) {
    const err = error?.response?.data?.message || error.message || 'Something went wrong';
    yield put(appActions.getMessageByPatientIdFailure(err))
    if (reject) reject(err)
  }
}
//DELETE MESSAGE BY ID
function* handleDeleteMessageById(action) {
  const { id, resolve, reject } = action.payload;
  try {
    const response = yield call(deleteMessageById, id);
    console.log("here saga delete response of message", response)

    if (response) {
      yield put(appActions.deleteMessageByIdSuccess(id));
      console.log("saga response success", response)
      if (resolve) resolve(response.data || {});
    } else {
      const error = new Error(response.data?.message || 'Error deleting message');
      yield put(appActions.deleteMessageByIdFailure(error));
      if (reject) reject(error);
    }
  } catch (error) {
    console.log(error);
    yield put(appActions.deleteMessageByIdFailure(error));
    if (reject) reject(error);
  }
}
//GET_REPORT_BY_PATIENT_ID
function* handleGetReportByPatientId(action) {
  const { patientId, resolve, reject } = action.payload;
  try {
    const response = yield call(getReportsByPatientId, patientId);
    if (response && response.data) {
      yield put(appActions.getReportsByPatientIdSuccess(response))
      if (resolve) resolve(response)
    }
    else {
      const error = response?.data?.message || 'No data found';
      yield put(appActions.getReportsByPatientIdFailure(error))
      if (reject) reject(error)
    }
  } catch (error) {
    const err = error?.response?.data?.message || error.message || 'Something went wrong';
    yield put(appActions.getReportsByPatientIdFailure(err));
    if (reject) reject(err)
  }
}
//GET_VIEWREPORT-BY_ID
function* handleGetViewReportById(action) {
  const { reportId, resolve, reject } = action.payload;
  console.log("report id", reportId)
  try {
    const response = yield call(getReportViewById, reportId);
    if (response) {
      console.log("API response in saga:", response);
      yield put(appActions.getViewReportByIdSuccess(response))
      if (resolve) resolve(response)
    }

  } catch (error) {
    yield put(appActions.getViewReportByIdFailure(error))
    if (reject) reject(error)
  }

}
//GET_DOWNLOAD_REPORT_BY_ID
function* handleGetDownloadReportById(action) {
  const { downloadId, resolve, reject } = action.payload;

  try {
    const response = yield call(getReportDownloadById, downloadId, {
      responseType: 'blob',
    });
    console.log("response of saga download", response)
    if (response) {
      yield put(appActions.getDownloadReportByIdSuccess(response));
      if (resolve) resolve(response)
    }
  } catch (error) {
    yield put(appActions.getDownloadReportByIdFailure(error));
    if (reject) reject(error)
  }
}
//GET_TREATMENT_BY_PATIENT_ID
function* handleGetTreatmentByPatientId(action) {
  const { patientId, resolve, reject } = action.payload;
  try {
    const response = yield call(getTreatmentByPatientId, patientId);
    if (response) {
      yield put(appActions.getTreatmentsByPatientIdSuccess(response))
      if (resolve) resolve(response)
    }

  } catch (error) {
    const err = error?.response?.data?.message || error.message || 'Something went wrong';
    yield put(appActions.getTreatmentsByPatientIdFailure(err));
    if (reject) reject(err);
  }
}

//GET TREATMENT BY ID
function* handleGetTreatmentById(action) {
  const { treatmentId, resolve, reject } = action.payload;
  try {
    const response = yield call(getTreatmentById, treatmentId);
    if (response) {
      yield put(appActions.getTreatmentByIdSuccess(response));
      console.log("saga response of treatmentid", response)
      if (resolve) resolve(response)
    }

  } catch (error) {
    yield put(appActions.getTreatmentByIdFailure(error.message || 'Failed to Fetch Treatment Data'));
    if (reject) reject(error);
  }
}

//POST DOCTOR PROFILE
function* handlePostDoctorProfile(action) {
  const { data, resolve, reject } = action.payload;
  try {
    const response = yield call(postDoctorProfile, data);
    if (response) {
      yield put(appActions.postDoctorProfileSuccess(response));
      if (resolve) resolve(response)
    }
  } catch (error) {
    yield put(appActions.postDoctorProfileFailure(error));
    if (reject) reject(error)
  }
}
//GET DOCTOR PROFILE BY ID
function* handleGetDoctorProfileById(action) {
  const { doctId, resolve, reject } = action.payload;
  try {
    const response = yield call(getDoctorProfileById, doctId);
    if (response) {
      const profileData = response.profile || response;
      yield put(appActions.getDoctorProfileByIdSuccess(profileData));
      if (resolve) resolve(profileData)
    }
  } catch (error) {
    yield put(appActions.getDoctorProfileByIdFailure(error));
    if (reject) reject(error)
  }
}

//POST CLINIC PROFILE

function* handlePostClinicProfile(action) {
  const { data, resolve, reject } = action.payload;
  try {
    const response = yield call(postClinicProfile, data);
    if (response) {
      yield put(appActions.postClinicProfileSuccess(response));
      if (resolve) resolve(response)
    }
  } catch (error) {
    yield put(appActions.postClinicProfileFailure(error));
    if (reject) reject(error)
  }
}

//GET CLINIC PROFILE BY ID
function* handleGetClinicProfileById(action) {
  const { clinicId, resolve, reject } = action.payload;

  try {
    const response = yield call(getClinicProfileById, clinicId);
    if (response) {
      const profileData = response.profile || response;
      yield put(appActions.getClinicProfileByIdSuccess(profileData));
      if (resolve) resolve(profileData)
    }
  } catch (error) {
    yield put(appActions.getClinicProfileByIdFailure(error));
    if (reject) reject(error)
  }
}

//UPDATE PATIENT BY ID
function* handleUpdatePatientById(action) {
  const { patientId, data, resolve, reject } = action.payload;
  try {
    const response = yield call(updatePatientById, patientId, data);
    if (response && response.patient) {
      yield put(appActions.updatePatientByIdSuccess({ data: response.patient }));
      if (resolve) resolve(response);
    } else {
      yield put(appActions.updatePatientByIdFailure('No status updated'));
    }

  } catch (error) {
    yield put(appActions.updatePatientByIdFailure(error));
    if (reject) reject(error);
  }
}
//UPDATE PATIENT INFO BY ID
function* handleUpdatePatientInfoById(action) {
  const { infoId, data, resolve, reject } = action.payload;
  try {
    const response = yield call(updatePatientInfoById, infoId, data);
    console.log("patient info updated", response);
    if (response && response.patientinfo) {
      yield put(appActions.updatePatientInfoByIdSuccess({ data: response.patientinfo }));
      if (resolve) resolve(response);
    }
  } catch (error) {
    yield put(appActions.updatePatientInfoByIdFailure(error));
    if (reject) reject(error);
  }
}

//UPDATE TAG BY ID
function* handleUpdateTagById(action) {
  const { tagId, data, resolve, reject } = action.payload;
  try {
    const response = yield call(updateTagById, tagId, data);
    console.log("tag data updated", response);
    if (response && response.tag) {
      yield put(appActions.updateTagByIdSuccess({ data: response.tag }));
      if (resolve) resolve(response.tag);
    }
  } catch (error) {
    yield put(appActions.updateTagByIdFailure(error));
    if (reject) reject(error);
  }
}
//UPDATE AREA BY ID
function* handleUpdateAreaById(action) {
  const { areaId, data, resolve, reject } = action.payload;
  try {
    const response = yield call(updateAreaById, areaId, data);
    console.log("area id", response);
    if (response && response.area) {
      yield put(appActions.updateAreaByIdSuccess({ data: response.area }));
      if (resolve) resolve(response.area);
    }
  } catch (error) {
    yield put(appActions.updateAreaByIdFailure(error));
    if (reject) reject(error);
  }
}

//POST TAG
function* handlePostTag(action) {
  const { data, resolve, reject } = action.payload;
  try {
    const response = yield call(postTag, data)
    if (response && response.tag) {
      yield put(appActions.postTagSuccess(response.tag))
      if (resolve) resolve(response.tag)
    }

  } catch (error) {
    yield put(appActions.postTagFailure(error))
    if (reject) reject(error)
  }

}
//POST AREA
function* handlePostArea(action) {
  const { data, resolve, reject } = action.payload;
  try {
    const response = yield call(postArea, data)
    if (response && response.area) {
      yield put(appActions.postAreaSuccess(response.area))
      if (resolve) resolve(response.area)
    }
  } catch (error) {
    yield put(appActions.postAreaFailure(error))
    if (reject) resolve(error)

  }
}
//POST PATIENTINFO
function* handlePostPatientInfo(action) {
  const { data, resolve, reject } = action.payload;
  try {
    console.log('[Saga] handlePostPatientInfo called with data:', data);
    const response = yield call(postPatientInfo, data)
    console.log('[Saga] postPatientInfo API response:', response);
    if (response && response.data) {
      yield put(appActions.postPatientInfoSuccess(response.data))
      if (resolve) resolve(response.data)
    } else {
      // Still resolve even if response structure is unexpected
      console.warn('[Saga] postPatientInfo: unexpected response structure:', response);
      yield put(appActions.postPatientInfoSuccess(response))
      if (resolve) resolve(response)
    }
  } catch (error) {
    console.error('[Saga] postPatientInfo error:', error);
    yield put(appActions.postPatientInfoFailure(error));
    if (reject) reject(error);
  }
}
//POST TREATMENT
function* handlePostTreatment(action) {
  const { data, resolve, reject } = action.payload;
  try {
    const response = yield call(postTreatment, data);
    if (response) {
      yield put(appActions.postTreatmentSuccess(response));
      if (resolve) resolve(response)
    }

  } catch (error) {
    yield put(appActions.postTreatmentFailure(error))
    if (reject) reject(error)
  }
}
//POST BILLING
function* handlePostBilling(action) {
  const { data, resolve, reject } = action.payload;
  try {
    const response = yield call(postBilling, data);
    if (response && response.billing) {
      yield put(appActions.postBillingSuccess(response))
      if (resolve) resolve(response)
      console.log("here billing response", response.billing)
    } else {
      // Still resolve even if response structure is unexpected
      yield put(appActions.postBillingSuccess(response))
      if (resolve) resolve(response)
    }

  } catch (error) {
    yield put(appActions.postBillingFailure(error))
    if (reject) reject(error)
  }
}
//POST UPLOAD
function* handlePostUpload(action) {
  const { data, resolve, reject } = action.payload;
  console.log('[Saga] handlePostUpload called with:', data);
  try {
    const response = yield call(postUpload, data);
    console.log('[Saga] postUpload API response:', response);

    if (response && response.file) {
      yield put(appActions.postUploadSuccess(response.file));
      if (resolve) resolve(response.file);
    } else {
      if (resolve) resolve(response);
    }
  } catch (error) {
    console.error('[Saga] postUpload API error:', error);
    yield put(appActions.postUploadFailure(error));
    if (reject) reject(error);
  }
}

// POST LOGO
function* handlePostUploadLogo(action) {
  const { data, resolve, reject } = action.payload;

  try {
    const response = yield call(postUploadLogo, data);
    console.log('[Saga] postUploadLogo API response:', response);

    if (response && response.logoUrl) {
      yield put(appActions.postUploadLogoSuccess(response.logoUrl));
      if (resolve) resolve(response.logoUrl);
    } else {
      yield put(appActions.postUploadLogoFailure('Unexpected response structure'));
      if (reject) reject('Unexpected response structure');
    }
  } catch (error) {
    console.error('[Saga] postUploadLogo API error:', error);
    yield put(appActions.postUploadLogoFailure(error));
    if (reject) reject(error);
  }
}

//POST PROFILEPIC
function* handlePostProfilePic(action) {
  const { data, resolve, reject } = action.payload;

  try {
    const response = yield call(postProfilePic, data);

    if (response && response.logoUrl) {
      yield put(appActions.postProfilePicSuccess(response.logoUrl));
      if (resolve) resolve(response.logoUrl);
    } else {
      yield put(appActions.postProfilePicFailure('Unexpected response structure'));
      if (reject) reject('Unexpected response structure');
    }
  } catch (error) {
    yield put(appActions.postProfilePicFailure(error));
    if (reject) reject(error);
  }
}

//POST CLINICS
function* handlePostClinics(action) {
  const { data, resolve, reject } = action.payload;
  try {
    const response = yield call(postClinic, data);
    if (response && response.data) {
      yield put(appActions.postClinicSuccess(response))
      if (resolve) resolve(response)
    }
  } catch (error) {
    yield put(appActions.postClinicFailure(error))
    if (reject) reject(error)
  }
}
//POST STAFF
function* handlePostStaff(action) {
  const { data, resolve, reject } = action.payload;
  try {
    const response = yield call(postStaff, data);
    if (response && response.staff) {
      yield put(appActions.postStaffSuccess(response))
      if (resolve) resolve(response)
    }
  } catch (error) {
    yield put(appActions.postStaffFailure(error))
    if (reject) reject(error)
  }

}
//GET STAFF
function* handleGetStaff(action) {
  const { token, params, resolve, reject } = action.payload;
  try {
    const response = yield call(getStaff, { token, params });
    if (response && response.data) {
      yield put(appActions.getStaffSuccess(response))
      if (resolve) resolve(response)
    }
  } catch (error) {
    yield put(appActions.getStaffFailure(error))
    if (reject) reject(error)
  }
}
//GET CLINICS
function* handleGetClinics(action) {
  const { token, resolve, reject } = action.payload;
  try {
    const response = yield call(getClinics, token);
    if (response) {
      yield put(appActions.getClinicSuccess(response))
      if (resolve) resolve(response)
    }
  } catch (error) {
    yield put(appActions.getClinicFailure(error))
    if (reject) reject(error)
  }
}

//GET CLINIC BY ID
function* handleGetClinicById(action) {
  const { clinicId, resolve, reject } = action.payload;
  try {

    const response = yield call(getClinicById, clinicId);
    yield put(appActions.getClinicByIdSuccess(response.clinic));
    if (resolve) resolve(response.clinic)

  } catch (error) {
    yield put(appActions.getClinicByIdFailure(error.message || 'Failed to Fetch clinic Data'))
    if (reject) reject(error)
  }

}

//GET ALL DOCTORS
function* handleGetAllDoctors(action) {
  const { resolve, reject } = action.payload;
  try {
    const response = yield call(getAllDoctors);
    yield put(appActions.getAllDoctorsSuccess(response.data));
    if (resolve) resolve(response.data);
  } catch (error) {
    yield put(appActions.getAllDoctorsFailure(error.message || 'Failed to Fetch Doctor Profiles'));
    if (reject) reject(error);
  }
}

//UPDATE CLINIC BY ID
function* handleUpdateClinicById(action) {
  const { clinicId, data, resolve, reject } = action.payload;
  try {
    const response = yield call(updateClinicById, clinicId, data);
    if (response) {
      yield put(appActions.updateClinicByIdSuccess({ data: response.clinic }));
      if (resolve) resolve(response.clinic);
    } else {
      yield put(appActions.updateClinicByIdFailure('No status updated'));
    }

  } catch (error) {
    yield put(appActions.updateClinicByIdFailure(error));
    if (reject) reject(error);
  }
}

function* handleGetPatientHistory(action) {
  const { patientId, resolve, reject } = action.payload;
  try {
    const response = yield call(getPatientHistory, patientId);

    if (response && response.data) {
      yield put(appActions.getPatientHistoryByPatientIdSuccess(response.data));
      if (resolve) resolve(response.data)
    }
  } catch (error) {
    yield put(appActions.getPatientHistoryByPatientIdFailure(error));
    if (reject) reject(error)
  }
}

function* handlePostTask(action) {
  const { data, resolve, reject } = action.payload;
  try {
    const response = yield call(postTask, data);
    if (response) {
      yield put(appActions.postTaskSuccess(response))
      if (resolve) resolve(response)
    }
  } catch (error) {
    yield put(appActions.postTaskFailure(error))
    if (reject) reject(error)
  }
}
function* handleGetTask(action) {
  const { token, resolve, reject } = action.payload;
  try {
    const response = yield call(getTask, token);
    if (response && response.data) {
      yield put(appActions.getTaskSuccess(response))
      if (resolve) resolve(response)
    }
  } catch (error) {
    yield put(appActions.getTaskFailure(error))
    if (reject) reject(error)
  }
}

function* handleGetBilling(action) {
  const { token, params, resolve, reject } = action.payload;
  try {
    const response = yield call(getBilling, { token, params });
    console.log('res in saga: ', response)
    if (response && response.data) {
      yield put(appActions.getBillingSuccess(response));
      if (resolve) resolve(response);
    }
  } catch (error) {
    yield put(appActions.getBillingFailure(error));
    if (reject) reject(error);
  }
}

function* handleGetSummary(action) {
  const { token, resolve, reject } = action.payload;
  try {
    const response = yield call(getSummary, token);
    if (response && response.summary) {
      yield put(appActions.getSummarySuccess(response))
      if (resolve) resolve(response)
    }
  } catch (error) {
    yield put(appActions.getSummaryFailure(error))
    if (reject) reject(error)
  }
}

export function* handleGetGoogleAuthUrl(action) {
  const { token, resolve, reject } = action.payload;
  try {
    const response = yield call(getGoogleAuthUrl, token);

    if (response?.url) {
      yield put(appActions.getGoogleAuthUrlSuccess(response));
      if (resolve) resolve(response);

      window.location.href = response.url;
    } else {
      throw new Error('Missing redirect URL');
    }
  } catch (error) {
    yield put(appActions.getGoogleAuthUrlFailure(error));
    if (reject) reject(error);
  }
}

function* handlePostComment(action) {
  const { taskId, data, resolve, reject } = action.payload;
  try {
    const response = yield call(postComment, taskId, data);
    if (response && response.message) {
      yield put(appActions.postTaskCommentByTaskIdSuccess({ taskId, message: response.message }));
      console.log("saga comment response", response)
      if (resolve) resolve(response);
    }
  } catch (error) {
    yield put(appActions.postTaskCommentByTaskIdFailure(error));
    if (reject) reject(error);
  }
}

function* handleGetSummaryStat(action) {
  const { token, resolve, reject } = action.payload;
  try {
    const response = yield call(getSummaryStat, token);
    if (response) {
      yield put(appActions.getSummaryStatSuccess(response))
      if (resolve) resolve(response)
    }
  } catch (error) {
    yield put(appActions.getSummaryStatFailure(error))
    if (reject) reject(error)
  }
}

function* handleGetMonthlyAppointments(action) {
  const { token, resolve, reject } = action.payload;
  try {
    const response = yield call(getMonthlyAppointments, token);
    if (response) {
      yield put(appActions.getMonthlyAppointmentsSuccess(response))
      if (resolve) resolve(response)
    }
  } catch (error) {
    yield put(appActions.getMonthlyAppointmentsFailure(error))
    if (reject) reject(error)
  }
}

function* handleGetTaskOverview(action) {
  const { token, resolve, reject } = action.payload;
  try {
    const response = yield call(getTaskOverview, token);
    if (response) {
      yield put(appActions.getTaskOverviewSuccess(response))
      if (resolve) resolve(response)
    }
  } catch (error) {
    yield put(appActions.getTaskOverviewFailure(error))
    if (reject) reject(error)
  }
}

function* handleGetAppointmentStatusSummary(action) {
  const { token, resolve, reject } = action.payload;
  try {
    const response = yield call(getAppointmentStatusSummary, token);
    if (response) {
      yield put(appActions.getAppointmentStatusSummarySuccess(response))
      if (resolve) resolve(response)
    }
  } catch (error) {
    yield put(appActions.getAppointmentStatusSummaryFailure(error))
    if (reject) reject(error)
  }
}

function* handleGetTransactions(action) {
  const { token, resolve, reject } = action.payload;
  try {
    const response = yield call(getTransactions, token);
    if (response) {
      yield put(appActions.getTransactionsSuccess(response))
      if (resolve) resolve(response)
    }
  } catch (error) {
    yield put(appActions.getTransactionsFailure(error))
    if (reject) reject(error)
  }
}

function* handleGetPendingTransactions(action) {
  const { token, resolve, reject } = action.payload;
  try {
    const response = yield call(getPendingTransactions, token);
    if (response) {
      yield put(appActions.getPendingTransactionsSuccess(response))
      if (resolve) resolve(response)
    }
  } catch (error) {
    yield put(appActions.getPendingTransactionsFailure(error))
    if (reject) reject(error)
  }
}

function* handlegetAvgEarningAndFollowUpRate(action) {
  const { token, resolve, reject } = action.payload;
  try {
    const response = yield call(getAvgEarningAndFollowUpRate, token);
    if (response) {
      yield put(appActions.getAvgEarningAndFollowUpRateSuccess(response))
      if (resolve) resolve(response)
    }
  } catch (error) {
    yield put(appActions.getAvgEarningAndFollowUpRateFailure(error))
    if (reject) reject(error)
  }
}

//POST
function* handlePostAVailability(action) {
  const { data, resolve, reject } = action.payload;
  try {
    const response = yield call(updateAvailability, data)
    if (response) {
      yield put(appActions.postAvailabilitySuccess(response))
      console.log("post response", response)
      if (resolve) resolve(response)
    }
  } catch (error) {
    yield put(appActions.postAvailabilityFailure(error))
    if (reject) reject(error)
  }
}

function* handleGetAvailableSlots(action) {
  const { token, params, resolve, reject } = action.payload;
  try {
    const response = yield call(getAvailableSlots, { token, params });
    if (response) {
      yield put(appActions.getAvailableSlotsSuccess(response));
      if (resolve) resolve(response);
    } else {
      const error = new Error('No slots found');
      yield put(appActions.getAvailableSlotsFailure(error));
      if (reject) reject(error);
    }
  } catch (error) {
    yield put(appActions.getAvailableSlotsFailure(error));
    if (reject) reject(error);
  }
}

function* handlePatientLookup(action) {
  const { phone, resolve, reject } = action.payload;
  try {
    const response = yield call(patientLookup, phone);
    yield put(appActions.patientLookupSuccess(response));
    if (resolve) resolve(response);
  } catch (error) {
    yield put(appActions.patientLookupFailure(error));
    if (reject) reject(error);
  }
}

export function* watchTokenAppointment() {
  yield takeLatest(appTypes.POST_APPOINTMENT_REQUEST, handlePostAppointment);
  yield takeLatest(appTypes.GET_APPOINTMENT_REQUEST, handleGetAppointment);
  yield takeLatest(appTypes.GET_APPOINTMENT_BY_ID_REQUEST, handleGetAppointmentById);
  yield takeLatest(appTypes.GET_APPOINTMENT_BY_PATIENTID_REQUEST, handleGetAppointmentByPatientId);
  yield takeLatest(appTypes.GET_AVAILABLE_SLOTS_REQUEST, handleGetAvailableSlots);
  yield takeLatest(appTypes.PATIENT_LOOKUP_REQUEST, handlePatientLookup);
}

export function* watchClinics() {
  yield takeLatest(appTypes.GET_CLINICS, handleGetClinic);
  yield takeEvery(appTypes.GET_TEMPLATE_BY_CLINICID_REQUEST, handleGetTemplateByClinicId);
  yield takeLatest(appTypes.POST_CLINIC_REQUEST, handlePostClinics);
  yield takeLatest(appTypes.GET_CLINIC_REQUEST, handleGetClinics);
  yield takeLatest(appTypes.POST_CLINICPROFILE_REQUEST, handlePostClinicProfile);
  yield takeEvery(appTypes.GET_CLINICPROFILE_BY_ID_REQUEST, handleGetClinicProfileById);
  yield takeLatest(appTypes.POST_UPLOADLOGO_REQUEST, handlePostUploadLogo);
  yield takeLatest(appTypes.UPDATE_CLINIC_BY_ID_REQUEST, handleUpdateClinicById);
  yield takeLatest(appTypes.GET_CLINIC_BY_ID_REQUEST, handleGetClinicById);
  yield takeLatest(appTypes.GET_ALL_DOCTORS_REQUEST, handleGetAllDoctors);
}
export function* watchStaff() {
  yield takeLatest(appTypes.POST_STAFF_REQUEST, handlePostStaff);
  yield takeLatest(appTypes.GET_STAFF_REQUEST, handleGetStaff);
}

export function* watchPatient() {
  yield takeLatest(appTypes.POST_PATIENT_REQUEST, handlePostPatient);
  yield takeLatest(appTypes.GET_PATIENT_REQUEST, handleGetPatient);
  yield takeLatest(appTypes.GET_PATIENT_BY_ID_REQUEST, handleGetPatientById);
  yield takeLatest(appTypes.GET_PATIENTINFO_BY_ID_REQUEST, handleGetPatientInfoById);
  yield takeLatest(appTypes.UPDATE_PATIENT_BY_ID_REQUEST, handleUpdatePatientById);
  yield takeLatest(appTypes.UPDATE_PATIENTINFO_BY_ID_REQUEST, handleUpdatePatientInfoById);
  yield takeLatest(appTypes.POST_PATIENTINFO_REQUEST, handlePostPatientInfo);
  yield takeLatest(appTypes.GET_PATIENT_HISTORY_BY_PATIENT_ID_REQUEST, handleGetPatientHistory);

}
export function* watchTag() {
  yield takeLatest(appTypes.GET_TAG_BY_PATIENT_ID_REQUEST, handleGetTagByPatientId);
  yield takeLatest(appTypes.GET_TAGS_REQUEST, handleGetTags);
  yield takeLatest(appTypes.UPDATE_TAG_BY_ID_REQUEST, handleUpdateTagById);
  yield takeLatest(appTypes.POST_TAG_REQUEST, handlePostTag)
}
export function* watchStatusRecord() {
  yield takeLatest(appTypes.UPDATE_STATUS_REQUEST, handleUpdateStatusRecord);
}
export function* watchMedicalRecord() {
  yield takeLatest(appTypes.POST_MEDICALRECORD_REQUEST, handlePostMedicalRecord);
  yield takeLatest(appTypes.GET_MEDICALRECORD_BY_PATIENTID_REQUEST, handleGetMedicalRecord);
  yield takeLatest(appTypes.DELETE_MEDICALRECORD_BY_ID_REQUEST, handleDeleteMedicalRecord);
  yield takeLatest(appTypes.GET_MEDICALRECORD_BY_ID_REQUEST, handleGetMedicalRecordById);
}
export function* watchFetchAvailability() {
  yield takeLatest(appTypes.FETCH_AVAILABILITY_REQUEST, handlefetchAvailability);
  yield takeLatest(appTypes.POST_AVAILABILITY_REQUEST, handlePostAVailability)
}
export function* watchTemplate() {
  yield takeEvery(appTypes.GET_TEMPLATE_BY_CLINICID_REQUEST, handleGetTemplateByClinicId);
  yield takeLatest(appTypes.POST_TEMPLATE_REQUEST, handlePostTemplate)
}
export function* watchFollowup() {
  yield takeLatest(appTypes.POST_FOLLOWUP_REQUEST, handlePostFollowup)
  yield takeLatest(appTypes.GET_FOLLOWUP_BY_PATIENTID_REQUEST, handleGetFollowupByPatientId)
}
export function* watchPayment() {
  yield takeLatest(appTypes.GET_BILLINGS_BY_PATIENTID_REQUEST, handleGetBillingsByPatientId);
  yield takeLatest(appTypes.POST_BILLING_REQUEST, handlePostBilling);
  yield takeLatest(appTypes.GET_BILLING_REQUEST, handleGetBilling);
  yield takeLatest(appTypes.GET_SUMMARY_REQUEST, handleGetSummary);
  yield takeLatest(appTypes.GET_BILLING_BY_ID_REQUEST, handleGetBillingsById)
}
export function* watchMessage() {
  yield takeLatest(appTypes.GET_MESSAGE_BY_PATIENTID_REQUEST, handleGetMessageByPatientId);
  yield takeLatest(appTypes.POST_MESSAGE_REQUEST, handlePostMessage);
  yield takeLatest(appTypes.DELETE_MESSAGE_BY_ID_REQUEST, handleDeleteMessageById);
}
export function* watchReport() {
  yield takeLatest(appTypes.GET_REPORT_BY_PATIENTID_REQUEST, handleGetReportByPatientId);
  yield takeLatest(appTypes.GET_VIEWREPORT_BY_ID_REQUEST, handleGetViewReportById);
  yield takeLatest(appTypes.GET_DOWNLOADREPORT_BY_ID_REQUEST, handleGetDownloadReportById);
  yield takeLatest(appTypes.POST_UPLOAD_REQUEST, handlePostUpload);
}
export function* watchTreatment() {
  yield takeLatest(appTypes.GET_TREATMENT_BY_PATIENTID_REQUEST, handleGetTreatmentByPatientId);
  yield takeLatest(appTypes.POST_TREATMENT_REQUEST, handlePostTreatment);
  yield takeLatest(appTypes.GET_TREATMENT_BY_ID_REQUEST, handleGetTreatmentById);
}
export function* watchDoctor() {
  yield takeLatest(appTypes.GET_DOCTORPROFILE_BY_ID_REQUEST, handleGetDoctorProfileById);
  yield takeLatest(appTypes.POST_DOCTORPROFILE_REQUEST, handlePostDoctorProfile);
  yield takeLatest(appTypes.POST_PROFILEPIC_REQUEST, handlePostProfilePic);
}
export function* watchArea() {
  yield takeLatest(appTypes.GET_AREA_BY_PATIENT_ID_REQUEST, handleGetAreaByPatientId);
  yield takeLatest(appTypes.GET_AREAS_REQUEST, handleGetAreas);
  yield takeLatest(appTypes.UPDATE_AREA_BY_ID_REQUEST, handleUpdateAreaById)
  yield takeLatest(appTypes.POST_AREA_REQUEST, handlePostArea)
}
export function* watchTask() {
  yield takeLatest(appTypes.POST_TASK_REQUEST, handlePostTask);
  yield takeLatest(appTypes.GET_TASK_REQUEST, handleGetTask);
  yield takeLatest(appTypes.POST_TASKCOMMENT_BY_TASKID_REQUEST, handlePostComment)
}

export function* watchGoogleAuth() {
  yield takeLatest(appTypes.GET_GOOGLE_AUTH_URL_REQUEST, handleGetGoogleAuthUrl)
}

function* handleGetCustomFields(action) {
  const { clinicId, resolve, reject } = action.payload;
  try {
    const response = yield call(getCustomFieldsByClinicId, clinicId);
    if (response) {
      yield put(appActions.getCustomFieldsSuccess(response));
      if (resolve) resolve(response);
    }
  } catch (error) {
    yield put(appActions.getCustomFieldsFailure(error));
    if (reject) reject(error);
  }
}

function* handlePostCustomFields(action) {
  const { data, resolve, reject } = action.payload;
  try {
    const response = yield call(postCustomPatientFields, data);
    if (response) {
      yield put(appActions.postCustomFieldsSuccess(response));
      if (resolve) resolve(response);
    }
  } catch (error) {
    yield put(appActions.postCustomFieldsFailure(error));
    if (reject) reject(error);
  }
}

export function* watchCustomFields() {
  yield takeLatest(appTypes.GET_CUSTOM_FIELDS_REQUEST, handleGetCustomFields);
  yield takeLatest(appTypes.POST_CUSTOM_FIELDS_REQUEST, handlePostCustomFields);
}

export function* watchDashboard() {
  yield takeLatest(appTypes.GET_SUMMARYSTAT_REQUEST, handleGetSummaryStat);
  yield takeLatest(appTypes.GET_MONTHLYAPPOINTMENT_REQUEST, handleGetMonthlyAppointments);
  yield takeLatest(appTypes.GET_TASKOVERVIEW_REQUEST, handleGetTaskOverview);
  yield takeLatest(appTypes.GET_APPOINTMENTSTATUSSUMMARY_REQUEST, handleGetAppointmentStatusSummary);
  yield takeLatest(appTypes.GET_TRANSACTIONS_REQUEST, handleGetTransactions);
  yield takeLatest(appTypes.GET_PENDINGTRANSACTIONS_REQUEST, handleGetPendingTransactions);
  yield takeLatest(appTypes.GET_AVGEARNINGANDFOLLOWUPRATE_REQUEST, handlegetAvgEarningAndFollowUpRate);
}

export default function* runSagas() {
  yield all([
    fork(watchTokenAppointment),
    fork(watchClinics),
    fork(watchPatient),
    fork(watchStatusRecord),
    fork(watchTag),
    fork(watchMedicalRecord),
    fork(watchFetchAvailability),
    fork(watchTemplate),
    fork(watchFollowup),
    fork(watchPayment),
    fork(watchMessage),
    fork(watchReport),
    fork(watchTreatment),
    fork(watchDoctor),
    fork(watchArea),
    fork(watchStaff),
    fork(watchTask),
    fork(watchGoogleAuth),
    fork(watchDashboard),
    fork(watchCustomFields)
  ]);
}